import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { ProgramarService } from "../programar.service";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class MantProgramarHistorialModal implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Programado",
      property: "FechaProgramado",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Inicio",
      property: "FechaIniciado",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Termino",
      property: "FechaTerminado",
      visible: true,
      isModelProperty: true,
    },
  ];
  list: any[] = [];

  first = true;

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: ProgramarService,
    private alerts: AlertasSwalService,
    public dialogRef: MatDialogRef<MantProgramarHistorialModal>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.getByUnidad(this.data).subscribe(
      (resultData) => {
        const data = resultData.map((m) => {
          return { ...m, TipoDesc: m.Tipo == 1 ? "Correctivo" : "Preventivo" };
        });

        this.tableComp.setData(data);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
